import CategoryDetail from './Main'

const route = {
  path: '/awards/:id',
  name: 'category-detail',
  component: CategoryDetail
}

export default route
